export enum ReverifyStatus {
  InitialVerification = "initial",
  ApplicantRequest = "applicant_request",
  DocumentsUpload = "documents_upload",
  Canceled = "canceled"
}

export enum ReverifyRequestStatus {
  Pending = "pending",
  Cancelled = "cancelled",
  Completed = "completed"
}

export interface ReverifyRequestActor {
  id: number | null;
  name?: string | null;
  type: string | null;
}

export interface ReverifyRequest {
  id: string;
  status: ReverifyRequestStatus;
  request_type: "applicant_request"; // The only type for now as per BE
  income_id: number | null;
  income_type?: string | null;
  methods: string[];
  created_at: string;
  updated_at: string;
  created_by?: ReverifyRequestActor;
  cancelled_by?: ReverifyRequestActor;
  completed_by?: ReverifyRequestActor;
}
